module.exports = __webpack_public_path__ + "static/media/ally_pro_3.a9257821.jpg";